import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visitorUUID: null,
};

const slice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setVisitorUUID: (state, action) => ({
      ...state,
      visitorUUID: action.payload,
    }),
    track: (state, action) => ({
      ...state,
    }),
    pageView: (state, action) => ({
      ...state,
    }),
  }
});

export const {
    track,
    pageView,
    setVisitorUUID,
} = slice.actions;
    
  export default slice.reducer;